<template>
<div class="leaflet-wrapper">
  <div class="head">
    <div class="title">学霸心得&高校宣传</div>

    <!-- 分页导航 -->
    <div class = "pager">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :page-sizes="[10,20,30,40]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="page.totalRecord">
      </el-pagination>
    </div>
  </div>

  <div class="poster-list">
    <div v-for="item in datas" :key="item.poster_url" class="poster-item" @click="handleClick(item)">
      <el-image class="poster-image"
        :src="item.poster_url"
        fit="fill" />
      <div class="video-title">{{item.title}}</div>
    </div>
  </div>

  <!-- 视频预览框 -->
  <!-- :visible.sync事件双向绑定，说明 -->
  <!-- 1)visible是子组件传入的参数名 -->
  <!-- 2)子组件关闭对话框时，发射事件this.$emit('update:visible', false) -->
  <!-- 3)父组件监听事件v-on:update:visible="isPreviewVideoShow=$event" -->
  <!-- 子组件对话框关闭时，父组件的控制变量也切换为false -->
  <PreviewVideo :visible.sync="isPreviewVideoShow" v-if="isPreviewVideoShow" :posterUrl="playPosterUrl" :videoUrl="playVideoUrl" />

</div>
</template>

<script>
import PreviewVideo from '@com/common/preview_video'


export default {
  components: {
    PreviewVideo
  },
 data() {
    return {
      datas: [],
      page: {
        pageSize: 10, //每页条数,  默认10条
        totalRecord: 0, //总条数
        totalPage: 0, //总页数
        currentPage:1  //当前显示页码
      },
      isPreviewVideoShow: false,
      playVideoUrl: '',
      playPosterUrl: ''
    };
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData(){
      const that = this
      let params = {
        currentpage: that.page.currentPage,
        pagesize: that.page.pageSize
      }
      that.axios.get('/homepage/leaflet/listwithpage',{params})
      .then(res =>{
        let {code, data, message}=res;
        if(code==0){
          that.page.totalRecord=data.total //总条数
          that.page.totalPage=data.pages  //总页数
          console.log(res.list)
          that.datas=data.list;
        }else{
            that.$message(message)
        }
      })
    },
    handleClick(item){
      this.playVideoUrl = item.video_url
      this.playPosterUrl = item.poster_url
      this.isPreviewVideoShow = true
    },
    // 修改每页记录数
    sizeChange(val) {
      this.page.pageSize = val
      this.reloadData()
    },
    //翻页
    currentChange(val) {
      this.page.currentPage=val
      console.log(this.page.pageNum)
      this.loadData()
    },
  }
}
</script>

<style lang="stylus" scoped>
.leaflet-wrapper
  margin: 20px 20px 20px 20px
  .head
    display: flex
    justify-content: space-between
    .title
      display: inline-block
      font-size: 20px
      font-weight: bold
    .pager
      display: inline-block
      margin-right: 100px
  .poster-list
    display: flex
    flex-flow: wrap
    .poster-item
      margin: 10px 10px 10px 10px
      &:hover
        background-color: #eeeeee
        cursor: pointer
      .poster-image
        width: 330px
        height: 210px
      .video-title
        text-align:center
</style>